import ModalContainer from "./ModalContainer";
import { Select, Form, Input, message } from "antd";
import { useEffect, useState } from "react";
import { useQueryCache } from "react-query";
import { putData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { ProviderList } from "../../../../custom-hooks/useFetchOutwardTransferProviders";
import Loader from "../../../../NewComponents/Loader/Loader.component";

const { Option } = Select;

interface IEditTransferLimit {
  open: boolean;
  handleCancel: () => void;
  title: string;
  confirmBtnText: any;
  cancelBtnTxt: string;
  _selectedBankCode: string | null;
  selectedProviderDetails: ProviderList | null;
}

const EditProviderInfo = ({
  open,
  handleCancel,
  title,
  cancelBtnTxt,
  confirmBtnText,
  _selectedBankCode,
  selectedProviderDetails,
}: IEditTransferLimit) => {
  const [form] = Form.useForm();
  const [accountId, setAccountId] = useState<number | undefined>(undefined);
  const [selectedBankCode, setSelectedBankCode] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const queryCache = useQueryCache();

  useEffect(() => {
    setSelectedBankCode(_selectedBankCode);
  }, [_selectedBankCode]);

  useEffect(() => {
    if (selectedBankCode) {
      setAccountId(
        selectedProviderDetails?.accounts?.find(
          (account) => account.bankCode === selectedBankCode,
        )?.id,
      );
    } else {
      setAccountId(
        selectedProviderDetails?.accounts?.find(
          (account) => account.bankCode === _selectedBankCode,
        )?.id,
      );
    }
  }, [selectedBankCode, selectedProviderDetails, _selectedBankCode]);

  useEffect(() => {
    form.setFieldsValue({
      maximumTransferAmount: selectedProviderDetails?.maximumTransferAmount,
      thresholdAmount: selectedProviderDetails?.thresholdAmount,
      providerName: selectedProviderDetails?.name,
    });
  }, [selectedProviderDetails]);

  const handleOk = () => {
    form.submit();
  };

  const onCancel = () => {
    handleCancel();
    form.resetFields();
  };

  const onFinish = async (values: {
    maximumTransferAmount: string;
    thresholdAmount: string;
  }) => {
    setIsLoading(true);
    let payload = null;

    if (selectedProviderDetails?.id === 2) {
      if (values.maximumTransferAmount || values.thresholdAmount) {
        payload = {
          outwardTransferProviderId: selectedProviderDetails?.id,
          outwardTransferProviderAccountId: accountId,
          maximumTransferAmount:
            values?.maximumTransferAmount ||
            selectedProviderDetails?.maximumTransferAmount,
          thresholdAmount:
            values?.thresholdAmount || selectedProviderDetails?.thresholdAmount,
        };
      } else {
        payload = {
          outwardTransferProviderId: selectedProviderDetails?.id,
          outwardTransferProviderAccountId: accountId,
          maximumTransferAmount: selectedProviderDetails?.maximumTransferAmount,
          thresholdAmount: selectedProviderDetails?.thresholdAmount,
        };
      }
    } else {
      payload = {
        outwardTransferProviderId: selectedProviderDetails?.id,
        maximumTransferAmount:
          values?.maximumTransferAmount ||
          selectedProviderDetails?.maximumTransferAmount,
      };
    }

    try {
      const response = await putData(
        ajaxEndpoints.UPDATE_OUTWARD_TRANSFER_PROVIDER,
        { ...payload },
      );

      if (response?.status === 200) {
        await queryCache.invalidateQueries(["fetchOutwardTransferProviders"]);
        message.success(response.data.message);
        form.resetFields();
        handleCancel();
      }
    } catch (error: any) {
      console.log(error);
      message.error(
        error.message || "Failed to update outwards transfer provider",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer
      open={open}
      handleOk={handleOk}
      handleCancel={onCancel}
      title={title}
      confirmBtnText={isLoading ? <Loader /> : confirmBtnText}
      cancelBtnTxt={cancelBtnTxt}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item label="Provider" name="providerName">
          <Input disabled size="large" />
        </Form.Item>
        <Form.Item
          htmlFor="maximum_transaction_amount"
          label="Maximum Transaction Amount"
          name="maximumTransferAmount"
        >
          <Input
            className="w-full"
            id="maximum_transfer_amount"
            size="large"
            type="number"
            // defaultValue={selectedProviderDetails?.maximumTransferAmount}
          />
        </Form.Item>
        {selectedProviderDetails &&
          selectedProviderDetails?.accounts?.length > 0 && (
            <>
              <Form.Item
                htmlFor="threshold_amount"
                label="Threshold Amount"
                name="thresholdAmount"
              >
                <Input
                  className="w-full"
                  id="threshold_amount"
                  size="large"
                  type="number"
                  // defaultValue={selectedProviderDetails?.thresholdAmount}
                />
              </Form.Item>
              <Form.Item label="Active Account">
                <Select
                  className="w-full"
                  id="payment_provider"
                  size="large"
                  value={selectedBankCode}
                  onChange={(value) => setSelectedBankCode(value)}
                >
                  {selectedProviderDetails?.accounts?.map((bank) => (
                    <Option value={bank.bankCode}>{bank.bankName}</Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}
      </Form>
    </ModalContainer>
  );
};

export default EditProviderInfo;
